/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/* eslint-disable max-len */
/**
 * Allows to make search request using the TomTom's
 * [Search API - Low Bandwidth Search](https://developer.tomtom.com/search-api/search-api-documentation-search/low-bandwidth-search).
 *
 * Parameters can be passed to the constructor or provided via convenient methods that can be chained until
 * the method {{#crossLink "LowBandwidthSearch/go:method"}}{{/crossLink}} performs the actual call.
 *
 * The call is asynchronous therefore the user have two options for receive the response:
 *  - Passing a callback function.
 *  - Use the {{#crossLink "Promise"}}{{/crossLink}} returned by the
 *    {{#crossLink "LowBandwidthSearch/go:method"}}{{/crossLink}} method to handle the response.
 *
 * @example
 * ```js
 * function callbackFn(results) {
 *   console.log(results);
 * }
 *
 * // Using a callback function
 * tomtom.lowBandwidthSearch()
 *   .key(<Your API key>) // this is optional if you defined a global key earlier
 *   .query("Amsterdam, The Netherlands")
 *   .callback(callbackFn)
 *   .go();
 *
 * // Or using a Promise
 * tomtom.lowBandwidthSearch()
 *   .key(<Your API key>) // this is optional if you defined a global key earlier
 *   .query("Amsterdam, The Netherlands")
 *   .go()
 *   .then(callbackFn);
 * ```
 *
 * The SDK provides a {{#crossLink "Promise"}}{{/crossLink}} polyfill for browsers (IE<9)
 * without native ECMAScript 6 support.
 *
 * @class LowBandwidthSearch
 * @extends Search
 * @uses CenterMixin
 * @uses RadiusMixin
 * @uses BoundingBoxMixin
 * @uses CountrySetMixin
 * @uses OffsetMixin
 * @uses BestResultMixin
 * @uses ViewMixin
 * @uses QueryMixin
 * @uses TypeaheadMixin
 * @uses IdxSetMixin
 * @constructor
 * @module Services
 *
 * @param {Object}   [options]
 * @param {String}   [options.key] An API Key issued from <a href="https://developer.tomtom.com">Developer Portal</a>
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 * @param {Boolean}  [options.unwrapBbox=false] Changes the bounding box coordinates allowing longitudes that
 *  exceeds 180 degrees when is necessary. {{#crossLink "Search/unwrapBbox:method"}}More{{/crossLink}}
 * @param {Number}   [options.limit=10] Maximum number of responses that will be returned
 * @param {String} [options.view="Unified"] Geopolitical view
 * @param {String}   [options.language=null] Language to use in the response.
 *  The list with all the available codes can be found
 *  <a href="https://developer.tomtom.com/search-api/search-api-documentation/supported-languages">here</a>.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 *
 * @param {String}   [options.query] Text that will be searched.
 *  This parameter is required to be defined either in the options passed to the constructor or using the
 *  **query()** method.
 * @param {Boolean}  [options.typeahead=false] Enables the **predictive** mode
 * @param {Boolean}  [options.bestResult=false] Return only one result, the best match result.
 * @param {Number[]|String|L.LatLng|Object} [options.center] Location where results should be biased
 * @param {Number}   [options.radius=0] The search radius in meters using the coordinates given to the **center**
 *  option as origin.
 *  If the radius is zero the results will not be constrained.
 * @param {Number}   [options.offset=0] Starting offset of the returned results within the full result set
 * @param {String}   [options.countrySet] List of country codes for limit the search request to those specific
 *  political limits
 * @param {Object|Number[]|Object[]|String} [options.boundingBox] The bounding box is an area within the search
 *  results needs to limit to. If it is omitted then the whole world will be taken into consideration.
 * @param {String}   [options.idxSet] Specify which indexes to utilize for the search
 */
/* eslint-enable */
define(['./search', 'model/search/lowBandwidthSearch', '../validators'], function(search, model, validators) {
    'use strict';

    var SearchPrototype = search.prototype.constructor;

    function LowBandwidthSearch(options) {
        SearchPrototype.call(this, options);

        this.model = model;
        this.fields.type = {
            defaultValue: this.TYPE.lowBandwidth,
            visible: false
        };

        this.fields.idxSet = {
            validator: validators.string
        };

        /**
         * @ignore
         * Only lowBandwidthSearch doesn't support extendedPostalCodesFor property
         * That's why related field must be removed
         */
        delete this.fields.extendedPostalCodesFor;
    }

    LowBandwidthSearch.prototype = new SearchPrototype();
    LowBandwidthSearch.prototype.constructor = LowBandwidthSearch;

    return function(options) {
        return (new LowBandwidthSearch(options)).construct();
    };
});



// WEBPACK FOOTER //
// ./services/search/lowBandwidthSearch.js